
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compliance/resources/bulletin",
      function () {
        return require("private-next-pages/compliance/resources/bulletin.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compliance/resources/bulletin"])
      });
    }
  